// Subtle "· PWM Select" suffix for listing cards. Renders nothing for PWM Original (the default state).
// Placed inside the card's category overline so it inherits size, tracking and casing; grey instead of gold.
const SelectMark = ({ article, light = false }) => {
  if (article?.editorial_type !== "select") return null;
  return (
    <span className={`font-semibold ${light ? "text-white/60" : "text-neutral-500"}`} data-testid={`select-mark-${article.slug}`}>
      <span aria-hidden="true"> &middot; </span>PWM Select
    </span>
  );
};

export default SelectMark;
